export function DocsPersistentStatePage() {
  return (
    <div className="docs-article">
      <p className="docs-eyebrow">Platform</p>
      <div className="docs-title-row">
        <h1 className="docs-page-title">Persistent state</h1>
        <span className="badge badge--mock docs-page-status">Preview</span>
      </div>
      <p className="docs-lede">
        Lite supports Ephemeral channels. Stateful and Durable persistence are Preview capabilities
        for broader managed offerings, with Pro and Dedicated access starting privately with
        founders.
      </p>

      <div className="panel notice-panel docs-spatial-notice">
        <p className="page-prose">
          <strong>Lite: Ephemeral only.</strong> Events are live for current subscribers; retained
          state and restart recovery belong to the Persistence Preview.
        </p>
      </div>

      <h2 className="docs-heading">Persistence classes</h2>
      <dl className="detail-list">
        <div className="detail-row">
          <dt>Ephemeral</dt>
          <dd>Available in Lite. Messages provide live delivery to current subscribers only.</dd>
        </div>
        <div className="detail-row">
          <dt>
            Stateful <span className="badge badge--mock">Preview</span>
          </dt>
          <dd>
            Woven keeps the latest value for each space, epoch, entity, channel, and component key
            in a bounded in-memory cache. Entries can use a TTL and are removed with their owning
            scope. The state lifetime ends when the runtime restarts.
          </dd>
        </div>
        <div className="detail-row">
          <dt>
            Durable <span className="badge badge--mock">Preview</span>
          </dt>
          <dd>
            Uses the Stateful in-memory semantics and adds a bounded journal seam for an external
            persistence service. Managed restart recovery and hosted durable storage belong to the
            Persistence Preview.
          </dd>
        </div>
      </dl>

      <h2 className="docs-heading">Managed availability</h2>
      <p className="docs-body">
        Stateful and Durable service integration is in Preview for Pro and Dedicated, beginning with
        private founder deployments. Until a managed persistence profile explicitly includes restart
        recovery, applications should treat retained state as process-local.
      </p>
    </div>
  );
}
